import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, TextField } from '@mui/material';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../functions/axios';
import { parseDate } from '../../functions/functions';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DateSelectorSingle } from './DateSelectorSingle';
import { useLocation } from 'react-router-dom';

const NoteEdit = () => {
  const location = useLocation();
  const { user } = useAuthContext();
  const [note, setNote] = useState('');
  const [dateForm, setDateForm] = useState(location.state?.date || parseDate().day);
  const navigate = useNavigate();

  const postNoteData = useCallback(async () => {
    try {
      await axios.post('/notes', {
        date: dateForm,
        value: note,
        context: 'carriageNotes',
      });
      navigate('/carriageNotes', { state: { date: dateForm } });
    } catch (err) {
      console.log(err);
    }
  }, [dateForm, navigate, note]);

  if (!user) return null;

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 80px)' }}>
      <Box style={{ margin: '0 25px', display: 'flex', gap: '25px', alignItems: 'center', flexShrink: 0 }}>
        <DateSelectorSingle date={dateForm} setDate={setDateForm} />
      </Box>
      <Box style={{ padding: '25px', width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TextField
          style={{ color: 'white', flex: 1 }}
          value={note}
          fullWidth
          label='Notatka'
          multiline
          variant='outlined'
          onChange={(e) => setNote(e.target.value)}
          sx={{
            '& .MuiInputBase-root': {
              height: '100%',
              alignItems: 'flex-start',
            },
            '& .MuiInputBase-input': {
              height: '100% !important',
              overflow: 'auto !important',
            }
          }}
        />
      </Box>
      <Box style={{ display: 'flex', padding: '25px', width: '100%', justifyContent: 'space-between', flexShrink: 0 }}>
        <Button variant='outlined' style={{ width: '250px' }} onClick={navigate.bind(null, `/carriageNotes`, { state: { date: dateForm } })}>
          Wróć do listy
        </Button>
        <Box style={{ display: 'flex', gap: '20px' }}>
          <Button disabled={!note} variant='contained' style={{ width: '250px' }} onClick={postNoteData} startIcon={<SaveIcon />}>
            Zapisz
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NoteEdit;
